if (!customElements.get('smartcubing-ecosystem-switch')) {
    customElements.define(
        'smartcubing-ecosystem-switch',
        class SmartcubingEcosystemSwiper extends HTMLElement {
            constructor() {
                super();
                this.swiperEl = this.querySelector('.smartcubing-ecosystem-switch__container .swiper');
                this.switchBtn = this.querySelectorAll('.smartcubing-ecosystem-switch__tab');
                this.cubeStationSwiperEl = this.querySelector('.smartcubing-ecosystem-switch__card--cube_station .swiper');
            }

            connectedCallback() {
                this.initSwiper();
                this.initSwitchBtn();

                if (this.cubeStationSwiperEl) {
                    this.initCubeStationSwiper();
                }
            }

            initCubeStationSwiper() {
                this.cubeStationSwiper = new Swiper(this.cubeStationSwiperEl, {
                    allowTouchMove: false,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true,
                    },
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: false,
                    },
                })
            }

            initSwitchBtn() {
                this.switchBtn.forEach((btn) => {
                    btn.addEventListener('click', (e) => {
                        if (btn.classList.contains('active')) {
                            return;
                        } else {
                            this.switchBtn.forEach((btn) => {
                                btn.classList.remove('active');
                            })
                            btn.classList.add('active');
                            e.preventDefault();
                            this.swiper.slideTo(Array.from(this.switchBtn).indexOf(btn));
                        }
                    })
                })
            }

            initSwiper() {
                // const prev = this.querySelector('.smartcubing-ecosystem-switch__navigation .swiper-btn-prev');
                // const next = this.querySelector('.smartcubing-ecosystem-switch__navigation .swiper-btn-next');
                // const pagination = this.querySelector('.swiper-pagination');
                this.swiper = new Swiper(this.swiperEl, {
                    allowTouchMove: false,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true,
                    },
                    autoHeight: true,
                })
            }
        }
    );
}
